import mixinArray from './array'
import mixinMixin from './mixin'
import mixinObject from './object'
import mixinProp from './prop'

export default {mixinArray,mixinMixin,mixinObject,mixinProp}